// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"eecb9ddf","242":"81f45d2a","265":"791b587d"}[chunkId] + ".chunk.css";
};